import styled from '@emotion/styled';
import { Box, css, Flex } from 'theme-ui';

export const DetailedContentContainer = styled.div(
  css({
    height: '100%',
    padding: [
      '32px 20px 72px 20px',
      '32px 40px 72px 40px',
      '70px 40px 100px 96px',
    ],
    flexDirection: 'column',
    background: 'white',
    // fix for https://app.asana.com/0/1202734593493325/1202782374290381
    '.year-heading+span': {
      display: 'none',
    },
  }),
);

export const OldDetailedContentContainer = styled(Box)(
  css({
    mt: 3,
    mx: 'auto',
    width: '4/5',
  }),
);
